import script from "./SetsCurrentProject.vue?vue&type=script&lang=ts"
export * from "./SetsCurrentProject.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__